<!-- eslint-disable vue/no-template-shadow -->
<template>
  <div>
    <custome-Dialog
      :dialog-visible.sync="cropperDialogVisible"
      confirm-text="裁剪"
      title="裁剪图片"
      width="50%"
      :confirm-disable="false"
      @confirm="confirmCropper"
      @close="cancelCropper"
    >
      <vue-cropper
        ref="cropper"
        class="cropper-warp"
        :auto-crop="true"
        output-type="png"
        :auto-crop-width="autoCropWidth"
        :auto-crop-height="autoCropHeight"
        :img="file.url"
      />
    </custome-dialog>
    <el-upload
      ref="upload"
      class="upload"
      action=""
      :auto-upload="true"
      :limit="limit"
      :file-list="uploadArr"
      :list-type="listType"
      :before-upload="beforeUpload"
      :on-exceed="uploadExceed"
      :on-change="changeFile"
      :on-remove="removeFile"
      :http-request="uploadRequest"
    >
      <i
        v-if="type === 'image'"
        class="
        el-icon-plus
        avatar-uploader-icon"
      />
      <el-button
        v-else
        type="primary"
      >
        上传文件
      </el-button>
      <div
        v-if="type === 'image'"
        slot="file"
        slot-scope="{file}"
      >
        <img
          class="el-upload-list__item-thumbnail"
          :src="file.url"
        >
        <span class="el-upload-list__item-actions">
          <span
            class="el-upload-list__item-preview"
            @click="handlePictureCardPreview(file)"
          >
            <i class="el-icon-zoom-in" />
          </span>
          <span
            class="el-upload-list__item-delete"
            @click="handleRemove(file)"
          >
            <i class="el-icon-delete" />
          </span>
        </span>
      </div>
      <el-progress
        v-if="showProgress"
        :percentage="progress"
      />
    </el-upload>
    <el-dialog :visible.sync="dialogVisible">
      <img
        width="100%"
        :src="dialogImageUrl"
        alt=""
      >
    </el-dialog>
  </div>
</template>
<script>
// import axios from 'axios';
import { VueCropper } from 'vue-cropper';
import { v4 as uuidv4 } from 'uuid';
import { Loading } from 'element-ui';
import customeDialog from '@/components/common/dialog.vue';
import axClient from '@/services';

export default {
  name: 'Upload',
  components: { customeDialog, VueCropper },
  props: {
    // 限制数量
    limit: {
      type: Number,
      default: 1,
    },
    // 文件列表
    fileList: {
      type: String,
      default: '',
    },
    // 自动剪裁宽度
    autoCropWidth: {
      type: Number,
      default: 160,
    },
    // 自动剪裁高度
    autoCropHeight: {
      type: Number,
      default: 160,
    },
    // 是否支持剪裁
    cropper: {
      type: Boolean,
      default: true,
    },
    // 上传的文件类型
    type: {
      type: String,
      default: 'image',
    },
    // 上传文件大小限制
    limitSize: {
      type: Number,
      default: 4096,
    },
  },
  data() {
    return {
      ossData: {}, // 阿里云返回的ossData
      cdnData: {}, // 阿里云返回的ossData 走cdn
      cropperDialogVisible: false, // 是否打开剪裁弹窗
      file: {}, // 当前上传的文件
      fileType: '',
      dialogVisible: false,
      dialogImageUrl: null,
      uploadArr: [],
      progress: 0, // 进度条数据
      showProgress: false, // 是否显示进度条
    };
  },
  computed: {
    listType() {
      if (this.type === 'image') {
        return 'picture-card';
      }
      return 'text';
    },
  },
  watch: {
    fileList(val) {
      if (typeof val === 'string' && val) {
        this.uploadArr = val && val.split(',').map((v) => ({ url: v, name: v.split('/').pop() }));
      } else {
        this.uploadArr = [];
      }
    },
  },
  mounted() {
    if (typeof this.fileList === 'string' && this.fileList) {
      this.uploadArr = this.fileList && this.fileList.split(',').map((v) => ({ url: v, name: v.split('/').pop() }));
    } else {
      this.uploadArr = [];
    }
  },
  methods: {
    // 放大图片
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    // 删除图片
    handleRemove(file) {
      const arr = this.fileList.split(',');
      arr.splice(arr.indexOf(file.url), 1);
      this.$emit('update:fileList', arr.join(','));
    },
    // 确认剪裁
    confirmCropper() {
      this.$refs.cropper.getCropData((data) => {
        this.file = this.dataURLtoFile(data, this.file.name);
        this.cropperDialogVisible = false;
        this.uploadRequest();
      });
    },
    // 取消剪裁
    cancelCropper() {
      this.cropperDialogVisible = false;
    },
    // 将base64转换为文件
    dataURLtoFile(dataurl, filename) {
      const arr = dataurl.split(',');
      const mime = arr[0].match(/:(.*?);/)[1];
      const bstr = atob(arr[1]);
      let len = bstr.length;
      const u8arr = new Uint8Array(len);
      while (len--) {
        u8arr[len] = bstr.charCodeAt(len);
      }
      return new File([u8arr], filename, { type: mime });
    },
    // 删除文件
    removeFile(val, fileList) {
      this.$emit('isProcess', false);
      this.$emit('update:fileList', fileList.map((v) => v.url).join(','));
    },
    // 上传之前回调
    beforeUpload(file) {
      const isLt = file.size / 1024 / 1024 < this.limitSize;
      let isType = true;
      if (!isLt) {
        this.$message.error(`文件大小不能超过${this.limitSize}Mb`);
        return false;
      }
      if (this.type === 'image') {
        // 上传图片
        if (!/(gif|jpg|jpeg|png|GIF|JPG|PNG)$/.test(file.type)) {
          this.$message.error('请上传正确格式的图片');
          isType = false;
          return false;
        }
      }
      if (this.type === 'xlsx') {
        // 上传图片
        if (!/(xlsx|xls|xltx|xlt|xlsm|xlsb|xltm|csv)$/.test(file.type)) {
          this.$message.error('请上传正确格式表格');
          isType = false;
          return false;
        }
      }
      if (isType && this.cropper && this.type === 'image') {
        this.cropperDialogVisible = true;
        return false;
      }
      if (this.type === 'video') {
        return true;
      }
      return true;
    },
    // 自定义上传方法
    async uploadRequest() {
      this.showProgress = true;
      this.ossData = await axClient.common.aliOssDirEnum();
      this.cdnData = await axClient.common.aliCdnDirEnum();
      const fileFormData = new FormData();
      fileFormData.append('name', this.file.name);
      fileFormData.append('key', `${this.ossData.dir}\${filename}`);
      fileFormData.append('policy', this.ossData.policy);
      fileFormData.append('OSSAccessKeyId', this.ossData.accessid);
      fileFormData.append('callback', this.ossData.callback);
      fileFormData.append('signature', this.ossData.signature);
      if (this.cropper && this.type === 'image') {
        fileFormData.append('file', this.file);
      } else {
        fileFormData.append('file', this.file);
      }
      const loadingInstance = Loading.service({ fullscreen: true, background: 'transparent', text: '努力上传中...' });
      // const data = await axios.post(this.ossData.host, fileFormData);
      const data = await axClient.common.uploadFile(this.ossData.host, fileFormData,
        {
          onUploadProgress: (progressEvent) => {
            this.progress = Math.floor((progressEvent.loaded / progressEvent.total) * 100);
          },
        });
      if (data.Status === 'OK') {
        let filePath = '';
        if (process.env.NODE_ENV === 'development') {
          filePath = `${this.ossData.host}${this.ossData.dir}${this.file.name}`;
        } else {
          filePath = `${this.cdnData.host}${this.cdnData.dir}${this.file.name}`;
        }
        // const filePath = `${this.cdnData.host}${this.cdnData.dir}${this.file.name}`;
        this.uploadArr = [...this.uploadArr, { name: this.file.name, url: filePath }];
        this.$emit('update:fileList', this.uploadArr.map((v) => v.url).join(','));
        loadingInstance.close();
        this.$message.success('上传成功');
        this.$emit('isProcess', false);
        this.showProgress = false;
        this.progress = 0;
        return false;
      }
      loadingInstance.close();
      this.$message.error('上传失败');
      return false;
    },
    // 上传文件改变
    changeFile(file) {
      this.$emit('isProcess', true);
      const uuid = uuidv4().replaceAll('-', '');
      const fileName = `${uuid}.${file.name.split('.').pop()}`;
      this.file = new File([file.raw], fileName, { type: file.raw.type });
      this.file.url = file.url;
    },
    // 超出文件上传限制
    uploadExceed() {
      this.$message.error('超出文件上传限制数量');
    },
  },
};
</script>
<style lang="scss" scoped>
.upload {
  ::v-deep .el-upload--picture-card {
    background: transparent;
    border: none;
    width: 80px;
    height: 80px;
  }
  ::v-deep .el-upload {
    width: 80%;
    text-align: left;
    .el-progress {
      position: absolute;
      bottom: -10px;
      left: 0;
      right: 0;
    }
  }
  ::v-deep .el-upload--picture-card {
    width: auto;
  }
  ::v-deep .el-upload-list__item {
    transition: none !important;
  }
  ::v-deep .el-upload-list--picture-card .el-upload-list__item {
    width: 80px;
    height: 80px;
    display: inline-flex;
    align-items: center;
    border-color: $--base-color-main;
    img {
      width: 100%;
      height: auto;
    }
  }
}
.avatar-uploader-icon {
  width: 80px;
  height: 80px;
  border-radius: 8px;
  background: rgba(33, 33, 33, 0.05);
  color: rgba(33, 33, 33, 0.4);
  font-weight: 800;
  font-size: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  &:hover {
    color: $--base-color-main;
  }
}
.cropper-warp {
  height: 400px !important;
}
</style>
